import React from "react";
import GatedFeatureModal from "../UpgradeModal/GatedFeatureModal";
import usePremiumModalStore from "../PremiumFeatureModal/store";

import {
    Feature,
    featureInformation,
    getPlansFeatureAvailableOn,
    PubliclyAvailablePlans
} from "@functions/featureAvailability";
import { Plan } from "@functions/plans/types";
import {
    getTitleForWorkspacePlan,
    getDescriptionForWorkspacePlan
} from "../../../routes/workspace/utils";

/**
 * Opens the upsell modal for a premium feature.
 *
 * @param featureId The premium feature to upsell.
 */
export function openUpsellFeatureModal(featureId: Feature): void {
    const { open: openModal, close: closeModal } = usePremiumModalStore.getState();

    const featureInfo = featureInformation[featureId];
    if (!featureInfo) {
        // Feature not recognised – silently fail to avoid crashing the UI.
        // This mirrors previous behaviour where an invalid featureId would never reach this point.
        return;
    }

    const availablePlans = getPlansFeatureAvailableOn(featureId)
        .filter((plan) => PubliclyAvailablePlans.includes(plan) && plan !== Plan.Public)
        .map((plan) => ({
            plan: getTitleForWorkspacePlan(plan),
            description: getDescriptionForWorkspacePlan(plan)
        }));

    const isEnterpriseOnly = availablePlans.length === 0;

    openModal(
        <GatedFeatureModal
            isOpen={true}
            onClose={closeModal}
            icon="fa-duotone fa-solid fa-lock"
            featureId={featureId}
            feature={featureInfo.readableName}
            description={featureInfo.description}
            learnMoreLink={featureInfo.docsUrl || ""}
            valueProps={[]}
            availablePlans={availablePlans}
            onlyOnePlan={isEnterpriseOnly || availablePlans.length === 1}
            singlePlan={
                isEnterpriseOnly
                    ? getTitleForWorkspacePlan(Plan.Enterprise)
                    : availablePlans[0]?.plan
            }
            enterpriseFeature={isEnterpriseOnly}
            className="z-[3000]"
        />
    );
}
